import { JSX } from 'react';
import { DropdownButton, Dropdown } from 'react-bootstrap';

const getTimestampHour = (timestamp: string): string => {
  const hour = Number(timestamp.substring(11, 13));
  if (hour === 0 || hour === 12) return '12';
  if (hour < 12) return timestamp.substring(11, 13);
  return `${hour - 12}`.padStart(2, '0');
};

const getTimestampMinute = (timestamp: string): string => timestamp.substring(14, 16);

const getTimestampAmpm = (timestamp: string): string =>
  Number(timestamp.substring(11, 13)) < 12 ? 'AM' : 'PM';

interface TimeSelectionProps {
  readOnly: boolean;
  handleHour: (hour: string | null) => void;
  handleMinute: (minute: string | null) => void;
  handleAmpm: (ampm: 'am' | 'pm' | null) => void;
  timestamp?: string;
}

export const TimeSelection = ({
  readOnly,
  handleHour,
  handleMinute,
  handleAmpm,
  timestamp
}: TimeSelectionProps): JSX.Element => {
  const noSelection = !timestamp;
  return (
    <div className='time-selection'>
      <DropdownButton
        disabled={readOnly}
        className='time-dropdown hour'
        title={noSelection ? '--' : getTimestampHour(timestamp)}
      >
        {Array.from({ length: 12 }, (_, hourIndex) => hourIndex).map(hourIndex => {
          const hour = `${hourIndex === 0 ? 12 : hourIndex}`;
          return (
            <Dropdown.Item key={hour} eventKey={hour} onClick={() => handleHour(hour)}>
              {hour.padStart(2, '0')}
            </Dropdown.Item>
          );
        })}
      </DropdownButton>
      :
      <DropdownButton
        disabled={readOnly}
        className='time-dropdown minute'
        title={noSelection ? '--' : getTimestampMinute(timestamp)}
      >
        {Array.from({ length: 60 }, (_, minIndex) => minIndex).map(minIndex => {
          const min = minIndex.toString();
          return (
            <Dropdown.Item key={min} eventKey={min} onClick={() => handleMinute(min)}>
              {min.padStart(2, '0')}
            </Dropdown.Item>
          );
        })}
      </DropdownButton>
      <DropdownButton
        disabled={readOnly}
        className='time-dropdown ampm'
        title={noSelection ? '--' : getTimestampAmpm(timestamp)}
      >
        {['am', 'pm'].map(ampm => (
          <Dropdown.Item key={ampm} eventKey={ampm} onClick={() => handleAmpm(ampm as 'am' | 'pm')}>
            {ampm.toLocaleUpperCase()}
          </Dropdown.Item>
        ))}
      </DropdownButton>
    </div>
  );
};
